export default __webpack_public_path__ + "static/media/Word.5f85fabe.png";